// @flow
import * as React from 'react';

import { useTranslator } from '@gandi/translate';
import { Steps, Step } from '@gandi/ui';

type Props = {
  currentStep: number,
};
export function Header({ currentStep }: Props): React.MixedElement {
  const { __ } = useTranslator();

  return (
    <Steps active={currentStep}>
      <Step>{__('Type')}</Step>
      <Step>{__('CSR')}</Step>
      <Step>{__('Validation method')}</Step>
    </Steps>
  );
}
